const PluginDownloadButtons = ({ liteUrl, proUrl, className }) => {
    return <div className={`mt-8 sm:mt-12 flex flex-col sm:flex-row justify-center gap-4 sm:gap-6 ${className}`}>
        <a
            href={liteUrl}
            className="no-underline px-6 py-3 inline-flex text-base sm:text-md font-medium text-center rounded-full border-green-500 bg-green-500 hover:bg-green-600 transition duration-300 shadow-lg focus:ring-4 focus:ring-green-400 text-white focus:outline-none hover:no-underline text-green-700">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
            Download for Aronium Lite
        </a>
        <a
            href={proUrl}
            className="no-underline px-6 py-3 inline-flex text-base sm:text-md font-medium text-center rounded-full border-sky-500 bg-sky-500 hover:bg-sky-600 transition duration-300 shadow-lg focus:ring-4 focus:ring-sky-400 text-white focus:outline-none hover:no-underline text-sky-700">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6 mr-3">
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
            </svg>
            Download for Aronium Pro
        </a>
    </div>
}

export default PluginDownloadButtons;